export const exampleData = [
    {
        exerciseName: "bench press",
        bodypart: "chest",
        date: "2023-12-27T01:44:27.202Z",
        weight: "80",
        reps: "5",
    },
    {
        exerciseName: "bench press",
        bodypart: "chest",
        date: "2023-12-28T01:45:27.202Z",
        weight: "85",
        reps: "5",
    },
    {
        exerciseName: "bench press",
        bodypart: "chest",
        date: "2023-12-29T01:46:27.202Z",
        weight: "90",
        reps: "5",
    },
    {
        exerciseName: "deadlift",
        bodypart: "back",
        date: "2023-12-27T02:44:27.202Z",
        weight: "100",
        reps: "5",
    },
    {
        exerciseName: "deadlift",
        bodypart: "back",
        date: "2023-12-28T04:44:27.202Z",
        weight: "110",
        reps: "5",
    },
    {
        exerciseName: "deadlift",
        bodypart: "back",
        date: "2023-12-29T03:44:27.202Z",
        weight: "120",
        reps: "5",
    },
    {
        exerciseName: "squats",
        bodypart: "upper legs",
        date: "2023-12-27T01:44:27.202Z",
        weight: "90",
        reps: "6",
    },
    {
        exerciseName: "squats",
        bodypart: "upper legs",
        date: "2023-12-28T02:44:27.202Z",
        weight: "95",
        reps: "6",
    },
    {
        exerciseName: "squats",
        bodypart: "upper legs",
        date: "2023-12-29T03:44:27.202Z",
        weight: "100",
        reps: "6",
    },
    {
        exerciseName: "bench press",
        bodypart: "chest",
        date: "2023-12-30T01:44:27.202Z",
        weight: "95",
        reps: "5",
    },
    {
        exerciseName: "bench press",
        bodypart: "chest",
        date: "2023-12-31T01:45:27.202Z",
        weight: "100",
        reps: "5",
    },
    {
        exerciseName: "bench press",
        bodypart: "chest",
        date: "2024-01-01T01:46:27.202Z",
        weight: "105",
        reps: "5",
    },
    {
        exerciseName: "squats",
        bodypart: "upper legs",
        date: "2023-12-30T03:44:27.202Z",
        weight: "105",
        reps: "6",
    },
    {
        exerciseName: "squats",
        bodypart: "upper legs",
        date: "2023-12-31T03:44:27.202Z",
        weight: "110",
        reps: "6",
    },
    {
        exerciseName: "deadlift",
        bodypart: "back",
        date: "2023-12-30T03:44:27.202Z",
        weight: "125",
        reps: "5",
    },
    {
        exerciseName: "deadlift",
        bodypart: "back",
        date: "2023-12-31T03:44:27.202Z",
        weight: "130",
        reps: "5",
    },
    {
        exerciseName: "deadlift",
        bodypart: "back",
        date: "2024-01-01T03:44:27.202Z",
        weight: "135",
        reps: "5",
    },
    {
        exerciseName: "squats",
        bodypart: "upper legs",
        date: "2024-01-01T03:44:27.202Z",
        weight: "120",
        reps: "6",
    },
    {
        exerciseName: "Bodyweight",
        bodypart: "bodyweight",
        date: "2024-01-01T03:44:27.202Z",
        weight: "90",


    },
    {
        exerciseName: "Bodyweight",
        bodypart: "bodyweight",
        date: "2024-01-20T03:44:27.202Z",
        weight: "82",
    },
    {
        exerciseName: "Bodyweight",
        bodypart: "bodyweight",
        date: "2024-01-30T03:44:27.202Z",
        weight: "76",
    },
    {
        exerciseName: "Bodyweight",
        bodypart: "bodyweight",
        date: "2024-02-20T03:44:27.202Z",
        weight: "72",
    },

]

export const allBodyParts = [
    "chest",
    "back",
    "upper legs",
    "lower legs",
    "upper arms",
    "shoulders",
    "waist",
];

export const colors = [
    '#FF6B6B', '#66BFBF', '#5CDB95', '#98C1D9', '#FFC857', '#6A0572', '#F28482', '#379683',
    '#A8DADC', '#B565A7', '#E63946', '#F4D35E', '#B8B8D1', '#F3EFEF', '#83C5BE', '#FFA69E',
    '#003049', '#FCBF49', '#456268', '#7B2D26', '#FF8A5B', '#FFC75F', '#FFEE93', '#A8DADC',
    '#FF4D4D', '#00CCCC', '#4DFF4D', '#4D4DFF', '#FFFF66', '#CC00CC', '#FF9933', '#99FF99',
    '#993333', '#FF99CC', '#33FF33', '#CCCCFF', '#FFCC00', '#CC0000', '#00CC00', '#0000CC',
    '#FF6699', '#669966', '#990000', '#99CCFF', '#FF6600', '#666699', '#009966', '#9900CC',
    '#6699FF', '#FF9999', '#006666', '#CC6699', '#66FF99', '#996666', '#00CC99', '#336699',
    '#FF3366', '#99CC00', '#0066CC', '#FF66FF', '#FF9900', '#CCCC66', '#6666FF', '#009999',
    '#FF0033', '#330066', '#99CC33', '#FF3366', '#3300CC', '#99CCFF', '#CC9966', '#3366CC',
    '#663333', '#9966CC', '#CCCC33', '#666633', '#FF33CC', '#FFCC33', '#66CCFF', '#FF6666',
    '#336600', '#990066', '#FF9900', '#00FF66', '#660033', '#33CCCC', '#CC33FF', '#FF3333',
    '#00FF00', '#000033', '#33FFCC', '#CC0033', '#006600', '#663366', '#33FF66', '#003300',
    '#9966FF', '#33CC33', '#FF6600', '#FF33FF', '#FF0033', '#00FFCC', '#FF3300', '#CC66CC',
    '#66CC66', '#9900CC', '#6600CC', '#0099CC', '#3300FF', '#FF66CC', '#FFCC99', '#990033',
    '#99FF00', '#CC3333', '#FF66FF', '#CC99CC', '#006666', '#66FF33', '#99FFCC', '#333300',
    '#CCFF66', '#FF9966', '#663399', '#006666', '#FF0033', '#003399', '#33FF99', '#9933CC'
];
